import RequiredTitle from "elements/RequiredTitle";
import { FormGroup, Input } from "reactstrap";

const ActionInfoSection = ({ name, description, onChange }) => {
  return (
    <>
      <FormGroup>
        <RequiredTitle title="Name" />
        <Input
          placeholder="Name"
          name="Name"
          value={name}
          onChange={onChange}
        />
      </FormGroup>
      <FormGroup>
        <h5>Description</h5>
        <Input
          placeholder="Describe this action"
          name="Description"
          value={description}
          onChange={onChange}
        />
      </FormGroup>
    </>
  );
};

export default ActionInfoSection;
